import { useState } from 'react'
import { api, ApiError } from '../../shared/api/client'

type LinkCodeResponse = {
  code: string
  deep_link: string
  expires_in_seconds: number
}

export function TelegramLinkCard() {
  const [result, setResult] = useState<LinkCodeResponse | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function create(): Promise<void> {
    setBusy(true)
    setError(null)
    try {
      const data = await api.post<LinkCodeResponse>('/telegram/link-codes')
      setResult(data)
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Не удалось создать код привязки')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="card-panel" style={{ marginBottom: 12 }}>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <div>
          <strong>Telegram-бот</strong>
          <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
            Редактируйте разборы, оценивайте и одобряйте эталоны в Telegram.
          </div>
        </div>
        <button className="secondary" disabled={busy} onClick={() => void create()}>
          {busy ? 'Создаю код…' : result ? 'Новый код' : 'Подключить Telegram'}
        </button>
      </div>

      {error && <div className="error-box" style={{ marginTop: 10 }}>{error}</div>}

      {result && (
        <div style={{ marginTop: 10 }}>
          <div className="muted" style={{ fontSize: 13, marginBottom: 6 }}>
            Откройте ссылку в Telegram — аккаунт привяжется к вашему профилю. Код действует{' '}
            {Math.round(result.expires_in_seconds / 60)} минут.
          </div>
          <div className="transcript" style={{ fontSize: 13 }}>
            {result.deep_link || result.code}
          </div>
          <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>
            Код: {result.code}
          </div>
        </div>
      )}
    </div>
  )
}
